import { BaseWidgetEditorComponent } from '@juvare/widget-ui/BaseWidgetEditorComponent';
import SquareIcon from '@mui/icons-material/Square';
import { Box } from '@mui/material';
import React from 'react';
import { useCommonFormUiTranslation } from '../hooks';
import { buildGeneralTab, buildHiddenTab, buildStyleTab, showWidgetEditDialog } from '../WidgetEditDialog';
import { defaultWidgetLabelProvider, handleWidgetUpdate, makeNewConfigUnique } from '../WidgetForm/Utils';
import { type } from './types';
const WidgetFormDivider = (props) => {
    if (props.editMode) {
        return (React.createElement(Box, { pt: 1, pb: 1 },
            React.createElement(Box, { sx: { borderBottom: (theme) => '1px solid ' + theme.palette.divider } })));
    }
    else {
        return React.createElement(Box, { sx: { borderBottom: (theme) => '1px solid ' + theme.palette.divider } });
    }
};
const WidgetFormDividerEditor = (props) => {
    const { t } = useCommonFormUiTranslation();
    return (React.createElement(BaseWidgetEditorComponent, Object.assign({}, props, { widgetLabelProvider: defaultWidgetLabelProvider, onEditWidget: (endEditing) => showWidgetEditDialog(props, endEditing, {
            title: 'Divider',
        }, buildGeneralTab(props), buildHiddenTab(props, { t }), buildStyleTab(props)) }),
        React.createElement(WidgetFormDivider, Object.assign({}, props))));
};
export const widgetFormDivider = {
    type,
    component: WidgetFormDivider,
    update: handleWidgetUpdate,
    icon: React.createElement(SquareIcon, { fontSize: 'small' }),
    editorComponent: WidgetFormDividerEditor,
    createWidget: (rootConfig, editorPath, widgets) => makeNewConfigUnique(rootConfig, editorPath, widgets, { type }),
};
